import { actionCreator } from 'utils';
import * as StoreTypes from 'redux/types/storeTypes';

// L O A D   S T O R E
export function loadStore() {
    return {
        type: StoreTypes.LOAD_STORE,
    };
}

export function loadStoreRes(data) {
    return {
        type: actionCreator(StoreTypes.LOAD_STORE, 'res'),
        data,
    };
}

export function loadStoreErr() {
    return {
        type: actionCreator(StoreTypes.LOAD_STORE, 'err'),
    };
}
// L O A D   S T O R E

// S E T   S T O R E   F I L T E R S
export function setStoreFilters(key, value) {
    return {
        type: StoreTypes.SET_STORE_FILTERS,
        key,
        value,
    };
}
// S E T   S T O R E   F I L T E R S

// R E S E T   S T O R E   F I L T E R S
export function resetStoreFilters() {
    return {
        type: StoreTypes.RESET_STORE_FILTERS,
    };
}
// R E S E T   S T O R E   F I L T E R S

// S E T   S T O R E   P A G I N A T I O N
export function setStorePagination(key, pagination) {
    return {
        type: StoreTypes.SET_STORE_PAGINATION,
        key,
        pagination,
    };
}
// S E T   S T O R E   P A G I N A T I O N

// T O G G L E   S T O R E   S T A T U S
export function toggleStoreStatus(id) {
    return {
        type: StoreTypes.TOGGLE_STORE_STATUS,
        id,
    };
}

export function toggleStoreStatusRes() {
    return {
        type: actionCreator(StoreTypes.TOGGLE_STORE_STATUS, 'res'),
    };
}

export function toggleStoreStatusErr() {
    return {
        type: actionCreator(StoreTypes.TOGGLE_STORE_STATUS, 'err'),
    };
}
// T O G G L E   S T O R E   S T A T U S

// A D D   S T O R E
export function addStore(data) {
    return {
        type: StoreTypes.ADD_STORE,
        data,
    };
}

export function addStoreRes() {
    return {
        type: actionCreator(StoreTypes.ADD_STORE, 'res'),
    };
}

export function addStoreErr() {
    return {
        type: actionCreator(StoreTypes.ADD_STORE, 'err'),
    };
}
// A D D   S T O R E

// E D I T   S T O R E
export function editStore(data) {
    return {
        type: StoreTypes.EDIT_STORE,
        data,
    };
}

export function editStoreRes() {
    return {
        type: actionCreator(StoreTypes.EDIT_STORE, 'res'),
    };
}

export function editStoreErr() {
    return {
        type: actionCreator(StoreTypes.EDIT_STORE, 'err'),
    };
}
// E D I T   S T O R E

// L O A D   E D I T A B L E   S T O R E
export function loadEditableStore(id) {
    return {
        type: StoreTypes.LOAD_EDITABLE_STORE,
        id,
    };
}

export function loadEditableStoreRes(data) {
    return {
        type: actionCreator(StoreTypes.LOAD_EDITABLE_STORE, 'res'),
        data,
    };
}

export function loadEditableStoreErr() {
    return {
        type: actionCreator(StoreTypes.LOAD_EDITABLE_STORE, 'err'),
    };
}
// L O A D   E D I T A B L E   S T O R E

// S E T   E D I T A B L E   S T O R E   D A T A
export function setEditableStoreData(data) {
    return {
        type: StoreTypes.SET_EDITABLE_STORE_DATA,
        data,
    };
}
// S E T   E D I T A B L E   S T O R E   D A T A
